import type {
  ApiApplicationApprove,
  ApiApplicationPage,
  ApiApplicationQuery,
  ApiCustomer,
  ApiCustomerPermission,
  ApiUsage,
  ApiUsageQuery,
  ApiUsageRequest,
} from './type/api-access'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const apiAccessApi = defineApi('operation', ({ prefix }) => {
  /**
   * 查询 API 申请列表，customerId 为商户 ID。
   * POST /openApi/application/query
   */
  function getApplications(params: ApiApplicationQuery) {
    return requestClient.post<ApiApplicationPage>(
      prefix('openApi/application/query'),
      params,
    )
  }

  /**
   * 通过申请并设置全量最终权限。
   * POST /openApi/application/approve
   */
  function approveApplication(params: ApiApplicationApprove) {
    return requestClient.post<null>(
      prefix('openApi/application/approve'),
      params,
    )
  }

  /**
   * 拒绝待处理申请。
   * POST /openApi/application/reject
   */
  function rejectApplication(params: { id: number }) {
    return requestClient.post<null>(
      prefix('openApi/application/reject'),
      params,
    )
  }

  /**
   * 查询客户 API 配置，不返回密钥。
   * POST /openApi/customer/detail
   */
  function getCustomer(params: { customerId: number }) {
    return requestClient.post<ApiCustomer>(
      prefix('openApi/customer/detail'),
      params,
    )
  }

  /**
   * 保存客户全量权限，立即生效。
   * POST /openApi/customer/savePermission
   */
  function savePermissions(params: ApiCustomerPermission) {
    return requestClient.post<null>(
      prefix('openApi/customer/savePermission'),
      params,
    )
  }

  /**
   * 停用客户 API，保留凭据和权限。
   * POST /openApi/customer/disable
   */
  function disableCustomer(params: { customerId: number }) {
    return requestClient.post<null>(prefix('openApi/customer/disable'), params)
  }

  /**
   * 恢复已停用的客户 API。
   * POST /openApi/customer/enable
   */
  function enableCustomer(params: { customerId: number }) {
    return requestClient.post<null>(prefix('openApi/customer/enable'), params)
  }

  /**
   * 清空商户全部 IP 白名单；没有白名单时也返回成功。
   * POST /openApi/customer/clearIpWhitelist
   */
  function clearIpWhitelist(params: { customerId: number }) {
    return requestClient.post<null>(
      prefix('openApi/customer/clearIpWhitelist'),
      params,
    )
  }

  /**
   * 查询累计开通客户数和权限调用次数；客户筛选仅影响调用次数。
   * POST /openApi/usage/query
   */
  function getUsage(params: ApiUsageQuery) {
    const request: ApiUsageRequest = {
      startDate: params.dateRange[0],
      endDate: params.dateRange[1],
      customerIds: params.customerIds?.map(Number),
    }
    return requestClient.post<ApiUsage>(prefix('openApi/usage/query'), request)
  }

  return {
    getApplications,
    approveApplication,
    rejectApplication,
    getCustomer,
    savePermissions,
    disableCustomer,
    enableCustomer,
    clearIpWhitelist,
    getUsage,
  }
})
